import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, TextField } from "material-ui"
import strings from "../../../localization/strings"
import { ISchedulePatternTemplate } from "../../../models"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import ChooseHierarchyChip from "../../../components/hierarchy/choose_hierarchy/ChooseHierarchyChip"
import * as utils from "../../../helpers/utils"
import AccountStore from "../../../stores/AccountStore"
interface IProps {
  editPatternTemplate: ISchedulePatternTemplate
  handleClose(): void
  handleAdd(patternTemplate: ISchedulePatternTemplate): void
  handleUpdate(patternTemplate: ISchedulePatternTemplate): void
}
interface IState {
  name: string
  errorName: string
  description: string
  hierarchyId: string
}

export default class AddPatternTemplateDialog extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      name: props.editPatternTemplate ? props.editPatternTemplate.Name : "",
      errorName: "",
      description: props.editPatternTemplate ? props.editPatternTemplate.Description : "",
      hierarchyId: props.editPatternTemplate ?
        props.editPatternTemplate.HierarchyId :
        HierarchySettingsStore.getGlobalLevelItemFilterId() ?
          HierarchySettingsStore.getGlobalLevelItemFilterId() :
          null,
    }
    autobind(this)
  }

  handleSave() {
    if (!this.checkValidate()) return
    const payload: ISchedulePatternTemplate = {
      Id: this.props.editPatternTemplate ? this.props.editPatternTemplate.Id : utils.guid(),
      Name: this.state.name.trim(),
      Description: this.state.description,
      HierarchyId: this.state.hierarchyId,
      ShiftTemplates: this.props.editPatternTemplate ? this.props.editPatternTemplate.ShiftTemplates : [],
    }
    this.props.editPatternTemplate ? this.props.handleUpdate(payload) : this.props.handleAdd(payload)
  }

  checkValidate() {
    let isValidate = true
    if (!this.state.name.trim()) {
      this.setState({ errorName: strings.NameRequired })
      isValidate = false
    }
    else if (AccountStore.getCurrentAccount().ScheduleData.PatternTemplates.filter(item => this.props.editPatternTemplate ? item.Id !== this.props.editPatternTemplate.Id : true).find(item => !item.Deleted && item.Name === this.state.name.trim())) {
      this.setState({ errorName: strings.Pattern_name_is_duplicated })
      isValidate = false
    }
    else {
      this.setState({ errorName: "" })
    }
    return isValidate
  }

  render() {
    return (
      <Dialog
        open
        autoScrollBodyContent
        title={this.props.editPatternTemplate ? strings.Edit_Pattern_Template : strings.New_Pattern_Template}
        titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
        actions={[
          <FlatButton
            label={strings.CANCEL}
            secondary
            onClick={this.props.handleClose}
          />,
          <FlatButton
            label={strings.SAVE}
            primary
            onClick={this.handleSave}
          />
        ]}
      >
        <hr />
        <div style={{ paddingRight: 20, paddingLeft: 20 }}>
          <ChooseHierarchyChip
            readonly={this.props.editPatternTemplate ? false : true}
            chipLabel={strings.HierarchyLevel}
            hierarchyItemId={this.state.hierarchyId}
            handleSelectHierarchy={hierarchyId => this.setState({ hierarchyId })}
          />
          <div style={{ width: "100%" }}>
            <TextField
              floatingLabelText={strings.Name}
              value={this.state.name}
              onChange={(e, value) => { this.setState({ name: value }, () => this.checkValidate()) }}
              errorText={this.state.errorName}
              errorStyle={{ position: "absolute", bottom: -10 }}
              fullWidth={true}
            />
          </div>
          <div style={{ width: "100%" }}>
            <TextField
              floatingLabelText={strings.Description}
              value={this.state.description}
              onChange={(e, value) => { this.setState({ description: value }) }}
              fullWidth={true}
            />
          </div>
        </div>
      </Dialog>
    )
  }
}